module.exports = {
    
  scrollToTop: function(pageClass) {
    jQuery('html, body').scrollTop(0);

    jQuery('.navbar-nav').find('li').map(function(index, el) {
        var elRef = jQuery(jQuery(el).find('a')[0])[0].href;
        if (window.location.href.indexOf(elRef) < 0) {
          jQuery(el).removeClass('active');
        }
      });

    _.map(AllPageClass, function(cl) {
      jQuery('body').removeClass(cl);
    });
    jQuery('body').addClass(pageClass);
  }
}